@if (viewModel(); as viewModel) {
    <bs-digital-system-bet-bar />
    <bs-digital-pick-list>
        @for (pick of viewModel.pickList; track pickTrackBy($index, pick)) {
            <bs-digital-system-bet-pick
                [pick]="pick"
                [systemBetPick]="systemBetPick(viewModel.systemBetState, pick)"
                [systemBetState]="viewModel.systemBetState"
                [oddsDisplayFormat]="oddsDisplayFormat"
                [removeButtonPosition]="removeButtonPosition"
                [removeButtonStyle]="removeButtonStyle"
                [isSelectionCheckboxVisible]="true"
                [msAutomation]="pick.id.toString()" />
        }
    </bs-digital-pick-list>
    <bs-digital-picks-toolbar [picks]="viewModel.systemBetState.picks" />
}
